import React, { useEffect, useState, useCallback } from "react";

import cn from "classnames";
import styles from "./AddBattery.module.scss";
import {
  getRequestInService as getRequest,
  putRequestInService as putRequest,
} from "services/axiosServiceBaseClient";
import { Link, useHistory } from "react-router-dom";
import LocalStorageService from "services/tokenlocalstorage.service";
import Master from "../Master";
import tokenlocalstorageService from "services/tokenlocalstorage.service";
import jwtDecode from "jwt-decode";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import notificationService from "services/notification.service";

function UserProfileShow(props) {
  const initialFormValues = {
    enterpriseName: "",
    zipCode: "",
    country: "",
    state: "",
    city: "",
    addressLine1: "",
    addressLine2: "",
    username: "",
    emailId: "",
    phoneNumber: "",
    id: 0,
  };

  var onlyView = true;

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [choosenFileName, setChoosenFileName] = useState("No Image Uploaded");
  const [stateList, setStateList] = useState([]);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      var size = parseFloat(img.size / (1024 * 1024)).toFixed(2);
      if (size > 2) {
        notificationService.showNonBlacklistedError(
          "",
          "Please select image size less than 2 MB."
        );
        return false;
      }
      setChoosenFileName(img.name);
      formValues.uploadSpec = URL.createObjectURL(img);
    }
  };

  const history = useHistory();

  const back = () => {
    history.push("/Dashboard");
  };

  const getUserDetail = useCallback(async () => {
    const token = tokenlocalstorageService.getLocalAccessToken();
    // console.log(token, "TOKEN");
    var decode = jwtDecode(token);

    setUserEmail(decode.email);
    const userRole = LocalStorageService.get("user-role");
    let currentRole = "";
    let email = "";
    email = decode.email;
    userRole.toLocaleLowerCase() === "admin"
      ? (currentRole = "admin")
      : (currentRole = "operator");
    setUserRole(currentRole);
    await getRequest(
      "bss/svc/" + currentRole + "/info"
    ).then((res) => {
      if (res && res?.data) {
        var temp = res?.data;
        if (temp) {
          // temp.firstName = temp.username.split(" ")[0];
          // temp.lastName = temp.username.split(" ")[1] ? temp.username.split(" ").pop() : "";
          temp.addressLine1 =
            res.data.addressLine1 + " " + res.data.addressLine2;
          setFormValues(temp);
        }
      }
    });
  }, [formValues]);

  useEffect(() => {
    getUserDetail(userEmail);
    getStates();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
    if (event.target.name == "stateId") {
      var index = event.nativeEvent.target.selectedIndex;
      setFormValues({ ...formValues, ["state"]: stateList[index] });
      if (value == -1) {
        setFormValues({ ...formValues, [name]: null });
      }
      // setFormValues({ ...formValues, ["city"]: -1 });
      // setFormValues({ ...formValues, ["cityId"]: -1 });
      setFormValues({ ...formValues, [name]: value });
      // headerFilter.state = event.nativeEvent.target[index].text;
      // delete headerFilter["city"];
      // setHeaderFilter({ ...headerFilter, ["state"]: value });
    }
  };

  const getStates = useCallback(async (string) => {
    await getRequestInAssets("getStates?countryId=1")
      .then((res) => {
        if (res.data != null) {
          setStateList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleUpdate = (e) => {
    e.preventDefault();
    let result = validate(formValues);
    if (
      Object.values(result).every((x) => {
        return x === "";
      })
    )
      try {
        if (formValues?.addressLine1.includes(formValues?.addressLine2)) {
          formValues.addressLine1 = formValues?.addressLine1.replace(
            formValues?.addressLine2,
            ""
          );
        }
        const requestParams =
          // addressLine1: formValues.addressLine1,
          // addressLine2: formValues.addressLine2,
          // city: formValues.city,
          // cityId: 0,
          // country: formValues.country,
          // countryId: 0,
          // createdAt: formValues.createdAt,
          // emailId: "ashukla3@shelrecharge.com",
          // enterpriseName: formValues.enterpriseName,
          // id: 3,
          // imagePath: formValues.imagePath,
          // isActive: true,
          // phoneNumber:formValues.phoneNumber,
          // state: formValues.state,
          // stateId: 0,
          // username: formValues.username,
          // zipCode: formValues.zipCode
          {
            addressLine1: formValues.addressLine1.trim(),
            addressLine2: formValues.addressLine2.trim(),
            city: formValues.city,
            cityId: formValues.cityId,
            country: formValues.country,
            countryId: formValues.countryId,
            createdAt: formValues.createdAt,
            emailId: formValues.emailId,
            enterpriseName: formValues.enterpriseName,
            id: formValues.id,
            siteId: formValues?.siteId,
            siteName: formValues?.siteName,
            isActive: formValues?.isActive,
            phoneNumber: formValues.phoneNumber,
            state: formValues.state,
            stateId: formValues.stateId,
            username: formValues.username,
            // formValues?.firstName.trim() + " " + formValues?.lastName.trim(),
            zipCode: formValues.zipCode,
          };
        putRequest(`bss/svc/${userRole}/update`, requestParams)
          .then((res) => {
            if (res && res?.data) {
              // history.push({
              //   pathname: "/UserProfile",
              // });
              back();
              notificationService.showNonBlacklisted(
                res?.config?.url,
                res?.data?.message
              );
            }
          })
          .catch((error) => {
            notificationService.showNonBlacklistedError(
              error?.config?.url,
              error?.response?.data?.message
            );
            return error;
          });
      } catch (error) {
        console.log("Error:-", error);
      }
    // console.log(`form values -----> ${JSON.stringify(formValues)} `);
    // console.log(`form errors -----> ${JSON.stringify(formErrors)} `);
  };

  const validate = (formValues) => {
    const errors = {};
    if (!formValues.username) {
      errors.username = "Please Enter Name";
      // } else if (/^\s*$/i.test(formValues.username)) {
      //   errors.username = "Please Enter Valid Name";
    } else if (!/^[a-zA-Z ]{2,30}$/.test(formValues.username)) {
      errors.username = "Please Enter Valid Name";
    } else {
      errors.username = "";
    }
    // if (
    //   formValues.lastName != "" &&
    //   !/^[A-Za-z]+$/i.test(formValues.lastName)
    // ) {
    //   errors.lastName = "Please Enter Valid Last Name";
    // }
    if (!formValues.enterpriseName) {
      errors.enterpriseName = "Please Enter Enterprise Name";
    } else {
      errors.enterpriseName = "";
    }
    if (!formValues.phoneNumber) {
      errors.phoneNumber = "Please Enter Contact Number";
    } else if (formValues.phoneNumber.length != 10) {
      errors.phoneNumber = "Please Enter Valid Contact Number";
    } else {
      errors.phoneNumber = "";
    }
    if (!formValues.addressLine1) {
      errors.addressLine1 = "Please Enter address";
    } else {
      errors.addressLine1 = "";
    }
    if (!formValues.state) {
      errors.state = "Please Enter State";
    } else {
      errors.state = "";
    }

    setFormErrors(errors);
    return errors;
  };

  return (
    <>
      <div className={cn(styles.flex_spacer)} />
      <div id="UserProfile_Block" className={cn(styles.flex_item1)}>
        <div
          id="UserProfile_Block1"
          className={cn(styles.flex1, styles.flex1_layout)}
        >
          <h2
            id="UserProfile_Heading"
            className={cn(styles.medium_title, styles.medium_title_layout)}
          >
            {"Profile"}
          </h2>

          <form id="UserProfile_Form">
            <div
              id="UserProfile_Form_layout"
              className={cn(styles.group, styles.group_layout)}
              style={{ marginTop: "50px" }}
            >
              <div
                d="UserProfile_Form_layout1"
                className={cn(styles.flex3, styles.flex3_layout)}
              >
                <h3
                  id="UserProfile_Form_title"
                  className={cn(styles.subtitle, styles.subtitle_layout)}
                >
                  {"My Profile"}
                </h3>

                <hr className={cn(styles.line, styles.line_layout)} />

                <div
                  id="UserProfile_Form_row1"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div id="UserProfile_Name" className={cn(styles.flex2_item)}>
                    <div
                      id="UserProfile_Name_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="UserProfile_Name_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Name"}
                      </div>

                      <input
                        id="UserProfile_Name_input"
                        type="text"
                        name="username"
                        // placeholder="skdfjsldkfj"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.username}
                        onChange={handleChange}
                        maxLength="50"
                        // disabled={true}
                        // required
                      />
                    </div>
                    <p>{formErrors.username}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  {/* <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Last Name"}
                      </div>
                      <input
                        type="text"
                        name="lastName"
                        className={cn(styles.line1, styles.line1_layout)}
                        // required
                        value={formValues.lastName}
                        onChange={handleChange}
                      // disabled={true}
                      />
                    </div>
                    <p>{formErrors.lastName}</p>
                  </div> */}
                  <div
                    id="UserProfile_EnterpriseName"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="UserProfile_EnterpriseName_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="UserProfile_EnterpriseName_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Enterprise Name"}
                      </div>
                      {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                      <input
                        id="UserProfile_EnterpriseName_input"
                        type="text"
                        name="enterpriseName"
                        className={cn(styles.line1, styles.line1_layout)}
                        // required
                        value={formValues.enterpriseName}
                        onChange={handleChange}
                        // disabled={true}
                        disabled={onlyView}
                        maxLength="50"
                      />
                    </div>
                    <p>{formErrors.enterpriseName}</p>
                  </div>
                </div>

                <div
                  id="UserProfile_Form_row2"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div id="UserProfile_Role" className={cn(styles.flex2_item)}>
                    <div
                      id="UserProfile_Role_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="UserProfile_Role_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Role"}
                      </div>
                      {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                      <input
                        id="UserProfile_Role_input"
                        type="text"
                        name="Role"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={userRole} //{"Reliance Admin"}
                        onChange={handleChange}
                        disabled={true}
                        // required
                      />
                    </div>
                  </div>
                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="UserProfile_ContactNumber"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="UserProfile_ContactNumber_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="UserProfile_ContactNumber_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Contact Number"}
                      </div>
                      {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                      <input
                        id="UserProfile_ContactNumber_input"
                        type="text"
                        name="phoneNumber"
                        className={cn(styles.line1, styles.line1_layout)}
                        // required
                        value={formValues.phoneNumber}
                        maxLength="10"
                        onChange={handleChange}
                        // disabled={true}
                        disabled={onlyView}
                      />
                    </div>
                    <p>{formErrors.phoneNumber}</p>
                  </div>
                </div>

                <div
                  id="UserProfile_Form_row3"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div id="UserProfile_Email" className={cn(styles.flex2_item)}>
                    <div
                      id="UserProfile_Email_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="UserProfile_Email_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Email"}
                      </div>
                      {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                      <input
                        id="UserProfile_Email_input"
                        type="text"
                        name="email"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.emailId}
                        onChange={handleChange}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="UserProfile_Address"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="UserProfile_Address_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="UserProfile_Address_input"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Address"}
                      </div>
                      {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                      <input
                        id="UserProfile_Address_input"
                        type="text"
                        name="addressLine1"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.addressLine1}
                        onChange={handleChange}
                        // disabled={true}
                        disabled={onlyView}
                        maxLength="250"
                      />
                    </div>
                    <p>{formErrors.addressLine1}</p>
                  </div>
                </div>

                <div
                  id="UserProfile_Form_row4"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div id="UserProfile_State" className={cn(styles.flex2_item)}>
                    <div
                      id="UserProfile_State_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="UserProfile_State_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"State"}
                      </div>
                      {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                      {/* <input
                        type="text"
                        name="state"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.state}
                        onChange={handleChange}
                        // disabled={true}
                      /> */}
                      <select
                        id="UserProfile_State_select"
                        name="stateId"
                        className={cn(styles.line1, styles.line1_layout)}
                        //value={formValues.stateId}
                        value={
                          formValues?.stateId && formValues?.stateId > 0
                            ? formValues?.stateId
                            : -1
                        }
                        onChange={handleChange}
                        // disabled={onlyView}
                        required
                        disabled={onlyView}
                      >
                        <option value="-1">State</option>

                        {stateList.map((obj) => {
                          return <option value={obj.id}>{obj.name}</option>;
                        })}
                      </select>
                    </div>
                    <p>{formErrors.state}</p>
                  </div>
                  <div className={cn(styles.flex2_spacer)} />
                </div>

                <div
                  id="UserProfile_Button_container"
                  className={cn(styles.flex9, styles.flex9_layout)}
                >
                  <Link to="/Dashboard">
                    <div
                      id="UserProfile_Button_container1"
                      className={cn(styles.flex9_item)}
                    >
                      <div
                        id="UserProfile_BackButton_background"
                        // onClick={reset}
                        className={cn(styles.block7, styles.block7_layout)}
                      >
                        <h5
                          id="UserProfile_BackButton_title"
                          className={cn(
                            styles.highlights1,
                            styles.highlights1_layout
                          )}
                        >
                          {"Back"}
                        </h5>
                      </div>
                    </div>
                  </Link>
                  <div className={cn(styles.flex9_spacer)} />

                  <div
                    id="UserProfile_UpdateButton"
                    className={cn(styles.flex9_item)}
                  >
                    <div
                      id="UserProfile_UpdateButton_background"
                      className={cn(styles.block9, styles.block9_layout)}
                      onClick={handleUpdate}
                      style={{
                        backgroundColor: "#315CBB",
                        position: "absolute",
                        height: "45px",
                        width: "120px",
                        borderRadius: "5px",
                      }}
                    >
                      <h5
                        id="UserProfile_UpdateButton_title"
                        className={cn(
                          styles.highlights2,
                          styles.highlights2_layout
                        )}
                      >
                        {"Update"}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default function UserProfile(props) {
  return (
    <>
      <Master opts={props} screen={UserProfileShow} showStatus={false} />
    </>
  );
}

UserProfile.inStorybook = true;
